<div class="edit-form">
    <h3>
      {{
        'VIDEOS - ' 
        + (data.mode === 'edit' ? ('Edit Record n.' + (data.index+1)) : ('Add New Record at position ' + (data.index!+1)) )
      }}</h3>
    <form
        [formGroup]="editForm"
        (ngSubmit)="saveRecord()"
    >
      <input
        formControlName="url"
        placeholder="YouTube URL"
        type="text"
        required
        (keydown)="preventSubmit($event)"
      />
      <input
        formControlName="title"
        placeholder="Title"
        type="text"
        required
        (keydown)="preventSubmit($event)"
      />
      <textarea
        formControlName="description"
        placeholder="Description"
      ></textarea>
      <button type="submit">Save</button>
      <button type="button" (click)="cancel()">Cancel</button>
    </form>
</div>